import React from 'react'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { TouchBackend } from 'react-dnd-touch-backend'
import { csx } from '@vtex/admin-ui'

import {
  getAccountName,
  CYPRESS_TESTING_ACCOUNT,
} from '../../../../core/utils/accountName'
import { MovementsModalProvider } from '../../context/MovementsModalProvider'
import { OccurrencesModalProvider } from '../../context/OccurrencesModalProvider'
import { AppWrapper } from '../AppWrapper'
import { CustomDragLayer } from '../CustomDragLayer'
import { InServiceList } from '../InServiceList'
import { MovementsModal } from '../MovementsModal'
import { OccurrencesModal } from '../OcurrencesModal'
import { OutOfStoreList } from '../OutOfStoreList'
import { WaitingList } from '../WaitingList'
import { IconArrows } from '../AppWrapper/icons/IconArrows'

const DND_BACKEND =
  process.env.NODE_ENV === 'test' ||
  getAccountName() === CYPRESS_TESTING_ACCOUNT
    ? HTML5Backend
    : TouchBackend

export const SalesAssociateTraking = () => {
  return (
    <AppWrapper>
      <DndProvider backend={DND_BACKEND}>
        <CustomDragLayer />
        <OccurrencesModalProvider>
          <OccurrencesModal />
          <MovementsModalProvider>
            <MovementsModal />
            <WaitingList />
            <IconArrows
              className={csx({
                position: 'absolute',
                top: 20,
                left: '50%',
                transform: 'translateX(-50%)',
              })}
            />

            <InServiceList />
            <OutOfStoreList />
          </MovementsModalProvider>
        </OccurrencesModalProvider>
      </DndProvider>
    </AppWrapper>
  )
}
